export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>
      <div className="relative container-page py-8 md:py-12">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12 lg:gap-10">
          {/* editorial lead */}
          <div className="lg:col-span-6">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-700">
              <span className="h-px w-8 bg-accent-600"></span>
              Vol.1286 · 今日出刊
            </p>
            <h1 className="mt-5 font-display text-3xl font-black leading-[1.2] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
              热门排行<b className="text-primary-600">爆款必看</b>
              <br />
              全网热议焦点<span className="text-accent-700">一站吃全</span>
            </h1>
            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              吃瓜日报每日盘点精选，从热榜排行到专题聚焦，帮你把碎片时间里最值得关注的瓜料与爆款事件理得明明白白，快速掌握当下的关注焦点。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a href="#toprank" className="btn-primary">
                <i className="ri-fire-line"></i>
                看今日热榜
              </a>
              <a href="#featured" className="btn-ghost">
                逛逛爆款精选
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="mt-7 flex flex-wrap gap-2">
              {["娱乐", "综艺", "影视", "音乐", "社会热议", "电竞"].map((c) => (
                <a
                  key={c}
                  href="#featured"
                  className="rounded-full border border-foreground-200 bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600 transition hover:border-accent-300 hover:text-accent-700"
                >
                  # {c}
                </a>
              ))}
            </div>
          </div>

          {/* big feature card */}
          <div className="lg:col-span-6">
            <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-100 shadow-lift">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20collage%20combining%20cinema%20clapperboard%20red%20velvet%20and%20warm%20paper%20textures%20with%20watermelon%20fresh%20slices%20and%20newspaper%20spread%2C%20rich%20warm%20red%20and%20green%20tones%2C%20stylish%20print%20editorial%20design%2C%20high%20detail&width=1100&height=700&seq=chigua-hero-feature&orientation=landscape"
                  alt="吃瓜日报今日头条：热剧收官后主演集体破圈营业"
                  className="h-60 w-full object-cover md:h-72"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-flashlight-fill"></i>
                  今日头条
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="label-cat bg-accent-100 text-accent-800">娱乐</span>
                  <span className="flex items-center gap-1"><i className="ri-fire-line text-accent-600"></i>热议 268万</span>
                  <span className="flex items-center gap-1"><i className="ri-time-line"></i>约 8 分钟</span>
                </div>
                <h3 className="mt-3 font-display text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  热剧收官后主演集体「破圈营业」成新标配，背后是审美还是生意？
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  当剧集收官不再是终点，主演们如何把角色热度延续到现实，编辑部带你看懂这股「后劲营业」现象与行业逻辑。
                </p>
                <a
                  href="#featured"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition group-hover:text-primary-700"
                >
                  展开深度盘点 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}